export default __webpack_public_path__ + "static/media/dra-ivani-welcome.95965b76.png";